import { Component, OnInit, Input } from "@angular/core";
import { TranslationModuleEnum } from "src/app/utils/translation-modules.enum";

@Component({
  selector: "app-product-card",
  templateUrl: "./product-card.component.html",
  styleUrls: ["./product-card.component.scss"],
})
export class ProductCardComponent implements OnInit {
  @Input() label: string = "";
  @Input() className: string;
  @Input() item: any;
  @Input() onCardClick: (product: any) => void; // Input method
  @Input() activeCard = null;
  @Input() lang: any;
  translationModulesEnum = TranslationModuleEnum;

  constructor() {}
  onGiftClick(id) {
    this.onCardClick(id);
  }
  ngOnInit(): void {
    console.log(this.item, "itemitem");
  }
}
